import React from 'react';
import { tomeCutVariant } from './tomeShape';

export interface TomeButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** `primary`: gilt, the one action that matters. `secondary`: inked outline. `quiet`: text only. */
  tone?: 'primary' | 'secondary' | 'quiet';
  fullWidth?: boolean;
  /** `hand` (default) cuts the corners slightly unevenly, seeded by `shapeSeed` or the label; `clean` keeps even corners. */
  cut?: 'hand' | 'clean';
  shapeSeed?: string | number;
}

/**
 * A native button inked for parchment, its corners hand-cut (asymmetric radii
 * from the `--tome-cut-*` tokens, so border, shadow and focus ring follow the
 * shape). Styling is CSS (hover, focus-visible
 * and disabled states included), so it carries no local state and every
 * native attribute passes through.
 */
export const TomeButton: React.FC<TomeButtonProps> = ({
  tone = 'primary', fullWidth, cut = 'hand', shapeSeed, className = '', type = 'button', ...rest
}) => <button {...rest} type={type} className={`tome-button ${className}`} data-tone={tone}
  data-full-width={fullWidth || undefined}
  data-cut={cut === 'hand' && tone !== 'quiet'
    ? tomeCutVariant(shapeSeed ?? (typeof rest.children === 'string' ? rest.children : rest['aria-label'] ?? tone)) : undefined} />;
